<template>
  <generic-view
    :title="$t('brain')"
    icon="brain"
    v-bind:searchable="false"
    v-bind:configurable="true"
    v-bind:configure_modal="configure_modal"
  >
    <div class="ui grid">
      <div class="two column row">
        <div class="column" v-for="(space, index) in spaces" v-bind:key="index">
          <h3 class="ui top attached header">{{ space.name }}</h3>
          <div class="ui attached segment">
            <div class="ui form">
              <div class="grouped fields">
                <div class="field" v-for="(device, idx) in space.devices" v-bind:key="idx">
                  <div class="ui slider checkbox">
                    <input
                      type="checkbox"
                      v-model="spaces[index].devices[idx].power"
                      v-on:change="switch_device(device)"
                    />
                    <label>{{ device.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-view>
</template>

<script>
import { local_api, toast } from "@/utils";
import GenericView from "@/components/GenericContainer";
import ConfigureModal from "./BrainConfigureModal";
// import Mumble from "mumble-js";

export default {
  components: {
    "generic-view": GenericView
  },
  data() {
    return {
      spaces: [],
      configure_modal: ConfigureModal
    };
  },
  methods: {
    switch_device(device) {
      local_api(this, "post", "/brain/do-switch-device", {
        g: device.gpio_pin,
        p: device.power
      })
        .then(r => {
          console.log(r);
        })
        .catch(err => {
          toast(this.$el, "error", err);
        });
    }
  },
  mounted() {
    let vm = this;
    var commds = [
      {
        name: "google",
        command: /^google (.+) por mi\s?(por favor)?$/,
        action: function(query, polite) {
          console.log(query, polite);
          if (polite) {
            // google the query
          } else {
            console.log(
              "I will google that for you but only if you say please"
            );
          }
        }
      }
    ];

    local_api(this, "post", "/brain/do-get-configuration")
      .then(config => {
        vm.spaces = config.setup.map(space => {
          space.devices.map(d => {
            commds.push({
              name: `${d.name} on`,
              command: `enciende ${d.name}`,
              action: function() {
                vm.$alertify.warning(`encendiendo ${d.name}`);
                vm.switch_device({ gpio_pin: d.gpio_pin, power: true });
              }
            });

            commds.push({
              name: `${d.name} off`,
              command: `apaga ${d.name}`,
              action: function() {
                vm.$alertify.warning(`apagando ${d.name}`);
                vm.switch_device({ gpio_pin: d.gpio_pin, power: true });
              }
            });

            d.power = false;
            return d;
          });
          return space;
        });

        // var mumble = new Mumble({
        //   language: "es-ES",
        //   debug: false, // set to true to get some detailed information about what's going on
        //   // define some commands using regex or a simple string for exact matching
        //   commands: commds,

        //   // define global callbacks (see docs for all)
        //   callbacks: {
        //     start: function(event) {
        //       console.log("Starting..", event);
        //     }

        //     // start, end, speech, recognizeMatch, etc
        //   }
        // });

        // mumble.start();
      })
      .catch(err => {
        toast(this.$el, "error", err);
      });
  },
  watch: {}
};
</script>
